export function isLongTextLocale(locale: string): boolean {
  const longTextLocales = ['de-DE'];
  return longTextLocales.includes(locale);
}
